import { atom } from "recoil";
import Organisation from "@higher/models/Organisation";

const CurrentOrganisation = atom<Organisation | undefined>({
  key: "currentOrgState",
  default: undefined,
});

export default CurrentOrganisation;
